<template>
    <v-dialog v-model="dialog" max-width="560">
        <template #activator="{on}">
            <v-btn v-on="on" small icon>
                <v-icon small>mdi-pencil</v-icon>
            </v-btn>
        </template>
        <v-card>
            <v-card-title>Update product price for {{ catalog.name }}</v-card-title>
            <v-card-text>
                <v-row>
                  <v-text-field v-model="model.price" label="Price" :prefix="currency.currency"></v-text-field>
                </v-row>
                <v-row>
                  <v-select :items="types" label="Price Type" v-model="model.type"></v-select>
                </v-row>
                <v-row>
                  <v-checkbox :items="types" label="VAT Included" v-model="model.includeVat" :false-value="0" :true-value="1"></v-checkbox>
                </v-row>
            </v-card-text>

            <v-card-actions>
                <v-btn outlined color="red" @click="dialog=false">Cancel</v-btn>
                <v-spacer />
                <v-btn outlined color="accent" @click="doUpdate">Save</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { mapActions } from 'vuex';
export default{
    data: () => ({
        dialog:false,
        model: {
            price: 0,
            type: 'fix',
            includeVat: 1
        },
        types: [
            {text:'Fix price', value:'fix'},
            {text:'Upcharge', value:'upcharge'}
        ]
    }),
    props:{
        currency: {
            type: Object,
            required: true
        },
        catalog: {
            type: Object,
            required: true
        },
        set: {
            type: Object,
            required: true
        }
    },
    methods: {
        ...mapActions('productSets', ['updatePrices']),
        doUpdate () {
            this.updatePrices({
                setId: this.set.id,
                catalogId: this.catalog.id,
                currencyId: this.currency.id,
                price: this.model
            }).then(() => {
                this.dialog=false
                this.$emit('update')
            })
        }
    }
}
</script>